import { render } from "./icon-documents.vue?vue&type=template&id=1fbf2d63"
import script from "./icon-documents.vue?vue&type=script&lang=js"
export * from "./icon-documents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__